/**
 * Calculates how many days are left before the contact's edit period expires.
 * Returns negative values if the deadline has already passed.
 */
export function calculateRemainingEditDays(contactedAt: string | Date, updatePeriodInDays: number) {
	const date = new Date(contactedAt);
	const warningDate = new Date(date);
	warningDate.setDate(warningDate.getDate() + updatePeriodInDays);
	const currentDate = new Date();

	return Math.ceil((warningDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24));
}
